import { ReactNode } from 'react'
import Header from '@/presentation/components/common/Header'
import { Period } from '@/core/shared/types/dashboard'

interface DriverDetailLayoutProps {
  children: ReactNode
  selectedPeriod: Period
  onPeriodChange: (period: Period, customDates?: { startDate: string; endDate: string }) => void
  onRefresh: () => void
  onBack: () => void
  lastUpdatedAt?: string
  isRefreshing?: boolean
}

export function DriverDetailLayout({
  children,
  selectedPeriod,
  onPeriodChange,
  onRefresh,
  onBack,
  lastUpdatedAt,
  isRefreshing,
}: DriverDetailLayoutProps) {
  return (
    <div className="min-h-screen bg-background dark:bg-background_dark">
      <div className="sticky top-0 z-50 bg-background dark:bg-background_dark border-b shadow-sm">
        <Header
          title="Detalhe do Motorista"
          subtitle="Verifique as informações do motorista"
          selectedPeriod={selectedPeriod}
          onPeriodChange={onPeriodChange}
          onBackClick={onBack}
          onRefresh={onRefresh}
          lastUpdatedAt={lastUpdatedAt}
          isRefreshing={isRefreshing}
          showShareButton={true}
        />
      </div>
      <div className="p-4 md:p-6 flex-grow">{children}</div>
    </div>
  )
}
